<script setup lang="ts">
import { watch } from 'vue'
import { RouterLink, RouterView } from 'vue-router'
import { useLanguageStore } from './stores/language'
import { useI18n } from 'vue-i18n'

const languageStore = useLanguageStore()
const { locale } = useI18n()

watch(
  () => languageStore.language,
  (newLang) => {
    const lang = newLang.toLowerCase()
    locale.value = lang
  }
)
</script>
<template>
  <!-- <header>
    <nav>
      <div class="wrapper">
        <RouterLink to="/">Login</RouterLink>
        <RouterLink to="/landing_user">Landing User</RouterLink>
        <RouterLink to="/landing_page_operator">Landing Operator</RouterLink>
        <RouterLink to="/access_permit_request">Access permit request flow </RouterLink>
      </div>
    </nav>
  </header> -->

  <RouterView />
</template>

<style scoped>
@font-face {
  font-family: 'TTSquares';
  font-weight: normal;
  font-style: normal;
  /* font-display: swap; */
  src:
    local('TTSquares'),
    url('@/assets/fonts/TTSquares-Regular.woff2') format('woff2');
}

@font-face {
  font-family: 'TTSquares-Bold';
  font-weight: normal;
  font-style: normal;
  /* font-display: swap; */
  src:
    local('TTSquaresBold'),
    url('@/assets/fonts/TTSquares-Bold.woff2') format('woff2');
}
@font-face {
  font-family: 'Barlow';
  src: url('@/assets/fonts/Barlow-Regular.ttf');
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: 'Antarlida';
  src: url('@/assets/fonts/Atartida-Light.otf');
  font-weight: normal;
  font-style: normal;
}
/* TODO remove */
nav a.router-link-exact-active:hover {
  background-color: transparent;
}

header .wrapper {
  display: flex;
  place-items: flex-start;
  flex-wrap: wrap;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--app-white);
}

nav a:first-of-type {
  border: 0;
}

@media (min-width: 1024px) {
  header {
    display: inline-block;
    place-items: top;
    padding-right: calc(var(--section-gap) / 2);
  }

  nav {
    text-align: left;
    margin-left: -1rem;
    font-size: 1rem;

    padding: 1rem 0;
    margin-top: 1rem;
  }
}
</style>
